export const topCategories = [
  {
    id: 1,
    title: "All India Institute of Medical Sciences, New Delhi",
    iconSrc: "assets/images/12.svg",
    courses: "Excellence in healthcare and research education",
    url: "https://neetsupport.com/college/aiims-new-delhi", // Added URL for AIIMS New Delhi
  },
  {
    id: 2,
    title: "Christian Medical College, Vellore",
    iconSrc: "assets/images/3.svg",
    courses: "Faith-driven commitment to healthcare service",
    url: "https://neetsupport.com/college/cmc-vellore", // Added URL for CMC Vellore
  },
  {
    id: 3,
    title: "JIPMER, Puducherry",
    iconSrc: "assets/images/5.svg",
    courses: "Leading Premier Institute for PostGraduate Medical Studies",
    url: "https://neetsupport.com/college/jipmer-puducherry", // JIPMER Puducherry
  },
  {
    id: 4,
    title: "IMS BHU, Varanasi",
    iconSrc: "assets/images/7.svg",
    courses: " Fostering knowledge through medical heritage",
    url: "https://neetsupport.com/college/ims-bhu-varanasi", // Added URL
  },
  {
    id: 5,
    title: "Amrita Vishwa Vidyapeetham, Faridabad",
    iconSrc: "assets/images/8.png",
    courses: "Holistic learning with modern healthcare innovation",
    url: "https://neetsupport.com/college/amrita-vishwa-vidyapeetham-faridabad", // Added URL
  },
  {
    id: 6,
    title: "Kasturba Medical College, Manipal",
    iconSrc: "assets/images/2.svg",
    courses: "Advancing medical education through research",
    url: "https://neetsupport.com/college/kmc-manipal",
  },
  {
    id: 7,
    title: "Armed Forces Medical College (AFMC), Pune",
    iconSrc: "assets/images/4.svg",
    courses: " Cutting-edge training for future specialists",
    url: "https://neetsupport.com/college/afmc-pune", // Added URL for AFMC Pune
  },
  {
    id: 8,
    title: "DR. D.Y. Patil Vidyapeeth, Pune",
    iconSrc: "assets/images/6.svg",
    courses: "Empowering healthcare with quality education",
    url: "https://neetsupport.com/college/dpu-pune", // Added URL
  },
];

const Data = [
  {
    "S.No": "1",
    Counselling: "Medical Counselling Committee (MCC)",
    State: "All India",
    "Type of State": "All India",
    "Counselling Type": "All India Quota",
    OfficialWebsite: "https://neetsupport.com/counselling/mcc-counselling",
    Registration: "https://neetsupport.com",
    logo: "https://cdnbbsr.s3waas.gov.in/s3e0f7a4d0ef9b84b83b693bbf3feb8e6e/uploads/2022/05/2022053043.jpg",
  },
  {
    "S.No": "2",
    Counselling:
      "Directorate General of Medical Education and Training,Uttar Pradesh",
    State: "Uttar Pradesh",
    "Type of State": "Open State",
    "Counselling Type": "Institutional",
    OfficialWebsite:
      "https://neetsupport.com/counselling/up-neet-counselling-2025",
    Registration: "https://neetsupport.com",
    logo: "/assets/images/IconClass/13.svg",
  },
  {
    "S.No": "3",
    Counselling:
      "Directorate Of Medical Education And Research (DMER), Maharashtra",
    State: "Maharashtra",
    "Type of State": "Open State",
    "Counselling Type": "Institutional",
    OfficialWebsite:
      "https://neetsupport.com/counselling/maharashtra-neet-ug-counselling-2026-live-schedule-procedure-fee",
    Registration: "https://neetsupport.com",
    logo: "/assets/images/IconClass/cet.webp",
  },
  {
    "S.No": "4",
    Counselling: "The Karnataka Examinations Authority(KEA), Karnataka",
    State: "Karnataka",
    "Type of State": "Closed State",
    "Counselling Type": "State",
    OfficialWebsite:
      "https://neetsupport.com/counselling/kea-neet-counselling-2025",
    Registration: "https://neetsupport.com",
    logo: "/assets/images/IconClass/kea.webp",
  },
];
export default Data;
